// src/components/AIBusinessTypeChecker.js
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { isGibberish } from "../utils/isGibberish";
import { BACKEND_BASE_URL } from "../config/appUrls";

const AIBusinessTypeChecker = ({ steps, triggerNextStep }) => {
  const { t, i18n } = useTranslation();
  const [errorOccurred, setErrorOccurred] = useState(false);

  const triggeredRef = useRef(false);

  const description =
    steps.manualTypeEntry?.value || steps.businessDesc?.value || "";
  console.log("Using business as:", description);

  useEffect(() => {
    const locale = i18n.language || "en";

    // Avoid triggering multiple times
    if (triggeredRef.current) return;
    if (typeof triggerNextStep !== "function") return;

    if (!description || isGibberish(description, locale)) {
      console.warn(
        "⚠️ Rejected invalid/gibberish business description:",
        description
      );
      triggerNextStep({ value: t("pacobot.fallbackBusiness") });
      triggeredRef.current = true;
      return;
    }

    const fetchBusinessType = async () => {
      try {
        const response = await axios.post(
          `${BACKEND_BASE_URL}/api/suggest-type`,
          { description, locale }
        );
        console.log("AI API response:", response.data);
        const suggestion = response.data?.suggestion?.trim() || "otro";
        console.log("AI API suggestion:", response.data?.suggestion?.trim());

        triggerNextStep({ value: suggestion });
      } catch (error) {
        console.error("❌ AI API error:", error);
        setErrorOccurred(true);
        triggerNextStep({ value: "otro" }); // fallback
      } finally {
        triggeredRef.current = true;
      }
    };

    fetchBusinessType();
  }, [description, i18n.language, triggerNextStep]);

  return (
    <p>
      {errorOccurred
        ? t("pacobot.businessTypeError") 
        : t("pacobot.studyingBusiness")}{" "}
      {/* Text shown while AI is working */}
    </p>
  );
};

export default AIBusinessTypeChecker;
